export const classes = {
  message:
    'text-xl text-grey-7 dark:text-mauve-2 font-normal text-center px-6 py-6',
};
